import { render, staticRenderFns } from "./home_product_1.vue?vue&type=template&id=bf08f1aa&scoped=true"
import script from "./home_product_1.vue?vue&type=script&lang=js"
export * from "./home_product_1.vue?vue&type=script&lang=js"
import style0 from "./home_product_1.vue?vue&type=style&index=0&id=bf08f1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf08f1aa",
  null
  
)

export default component.exports